import { PricingCalculator } from '@atlassian/bxp-product-pricing';
import { useMemo } from 'react';

import { useProductPricingStore } from '@atlassiansox/bxpkit-product-pricing-store';

export function usePricingCalculator() {
  const productPricingStore = useProductPricingStore();
  return useMemo(
    () => new PricingCalculator({ productPricingStore }),
    [productPricingStore]
  );
}
